import { render, staticRenderFns } from "./ConsultationForm.vue?vue&type=template&id=32ec139d&scoped=true&"
import script from "./ConsultationForm.vue?vue&type=script&lang=ts&"
export * from "./ConsultationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultationForm.vue?vue&type=style&index=0&id=32ec139d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec139d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
